// Announcements / News — PS/MS 96 M
// Transferred from old ps96act.com /feed

const announcements = [
  {
    id: 'november-2026-calendar',
    title: 'November 2026 Calendar',
    date: '2026-11-03',
    summary:
      'Our November calendar is here. NYC Schools Account sign-up support every Monday at 9:30 AM, ClassBank Double Dollar Days, Parent-Teacher Conferences on Thursday, November 5 (half day, 11:30 AM dismissal), the Fall Show on November 6, the High School Fair on November 13, the Parent Association meeting on November 19, the Fall Festival on November 24, and the Scholastic Book Fair from November 30 to December 4. Nuestro calendario de noviembre ya está disponible en inglés y español.',
    flyers: [
      {
        src: '/assets/images/flyers/november-2026-calendar-english.jpg',
        alt: 'November 2026 calendar for P.S. 96 Lions, Lanzetta School of the Arts, Collaboration and Technology. Every Monday (November 2, 9, 16, 23 and 30): NYC Schools Account sign-up support at 9:30 AM. Tuesday, November 3: Election Day, school building closed, remote learning day. Wednesday, November 4: ClassBank Double Dollar Day. Thursday, November 5: Parent-Teacher Conferences, half day, 11:30 AM dismissal; ClassBank Double Dollar Day. Friday, November 6: Fall Show performance, 9:00 to 10:00 AM. Tuesday, November 10: ClassBank Double Dollar Day; Food Pantry at 2:30 PM. Wednesday, November 11: Veterans Day, school closed. Thursday, November 12: Wear blue for paraprofessionals; ClassBank Double Dollar Day. Friday, November 13: High School Fair at 8:30 AM. Tuesday, November 17: Food Pantry at 2:30 PM. Thursday, November 19: Parent Association meeting at 2:30 PM. Tuesday, November 24: Fall Festival with food, games, prizes and more at 2:30 PM; Food Pantry at 2:30 PM. Wednesday, November 25: Healthy Smiles dental program. Thursday, November 26 and Friday, November 27: school closed for Thanksgiving, give thanks. Monday, November 30 through Friday, December 4: Scholastic Book Fair. Friday, December 4: Healthy Smiles dental program. QR codes link to the school website, Instagram, Facebook, NYC Schools Account and NYC Public Schools. We are thankful for all of our wonderful P.S. 96 students, families, and staff!',
        label: 'English',
      },
      {
        src: '/assets/images/flyers/november-2026-calendar-spanish.jpg',
        alt: 'Calendario de noviembre de 2026 de P.S. 96 Leones, Escuela Lanzetta de Artes, Colaboración y Tecnología. Todos los lunes (2, 9, 16, 23 y 30 de noviembre): soporte para inscribirse en las Escuelas de Nueva York a las 9:30 a.m. Martes 3 de noviembre: Día de las Elecciones, edificio escolar cerrado, día de aprendizaje a distancia. Miércoles 4 de noviembre: ¡Día de doble dólares en ClassBank! Jueves 5 de noviembre: reuniones de padres y profesores, medio día, salida a las 11:30 a.m.; ¡día de doble dólares en ClassBank! Viernes 6 de noviembre: actuación del espectáculo de otoño, 9:00 a 10:00. Martes 10 de noviembre: ¡día de doble dólares en ClassBank!; despensa de alimentos a las 2:30. Miércoles 11 de noviembre: Día de los Veteranos, no hay clases. Jueves 12 de noviembre: ¡vístase de azul para paraprofesionales!; ¡día de doble dólares en ClassBank! Viernes 13 de noviembre: feria de la escuela secundaria a las 8:30. Martes 17 de noviembre: despensa de alimentos a las 2:30. Jueves 19 de noviembre: reunión de la Asociación de Padres a las 2:30. Martes 24 de noviembre: ¡comida, juegos, premios y mucho más! a las 2:30; despensa de alimentos a las 2:30. Miércoles 25 de noviembre: programa dental Sonrisas Saludables. Jueves 26 y viernes 27 de noviembre: no hay clases, Acción de Gracias. Lunes 30 de noviembre al viernes 4 de diciembre: Feria del Libro Scholastic. Viernes 4 de diciembre: programa dental Sonrisas Saludables. Códigos QR al sitio web del colegio, Instagram, Facebook, la Cuenta de las Escuelas de la Ciudad de Nueva York y las Escuelas Públicas de la Ciudad de Nueva York. ¡Estamos muy agradecidos con todos nuestros increíbles estudiantes, familias y miembros del personal de la Escuela Pública 96!',
        label: 'Español',
      },
    ],
    details: [
      {
        heading: 'This month',
        items: [
          'Every Monday: NYC Schools Account sign-up support at 9:30 AM',
          'Tuesday, November 3: Election Day — remote learning day, school building closed',
          'Thursday, November 5: Parent-Teacher Conferences — half day, 11:30 AM dismissal',
          'Friday, November 6: Fall Show performance, 9:00–10:00 AM',
          'ClassBank Double Dollar Days: November 4, 5, 10 and 12',
          'Food Pantry every Tuesday at 2:30 PM (November 10, 17 and 24)',
          'Wednesday, November 11: Veterans Day — school closed',
          'Thursday, November 12: Wear blue for paraprofessionals',
          'Friday, November 13: High School Fair, 8:30 AM',
          'Thursday, November 19: Parent Association meeting, 2:30 PM',
          'Tuesday, November 24: Fall Festival — food, games, prizes and more, 2:30 PM',
          'Wednesday, November 25 and Friday, December 4: Healthy Smiles dental program',
          'Thursday–Friday, November 26–27: Thanksgiving — school closed',
          'Monday, November 30 – Friday, December 4: Scholastic Book Fair',
        ],
      },
    ],
    pdf: '/assets/documents/ps96-calendar-november-2026.pdf',
    pdfLabel: 'View the November calendar (PDF, English and Spanish)',
  },
  {
    id: 'family-movie-night-2026-10-23',
    title: 'Family Movie Night at PS 96: Hotel Transylvania',
    date: '2026-10-15',
    summary:
      'Movie time! Join us for a family movie night on Friday, October 23 at 3:00 PM. Tickets are $5.00 per family (cash only) and include the movie, popcorn, a drink, and candy for everyone. Students must be accompanied by an adult. Presented with Global Kids. ¡Noche de cine en PS96! El 23 de octubre a las 3:00 pm. $5.00 por familia (¡solo efectivo!).',
    flyers: [
      {
        src: '/assets/images/flyers/family-movie-night-english.jpg',
        alt: 'Family Movie Night flyer in English: Movie Night at PS 96, Hotel Transylvania, October 23 at 3:00 PM. $5.00 per family, cash only, includes the movie, popcorn, drink and candy for everyone. Students must be accompanied by an adult.',
        label: 'English',
      },
      {
        src: '/assets/images/flyers/family-movie-night-spanish.jpg',
        alt: 'Volante de la Noche de Cine en español: Noche de cine en PS96, Hotel Transylvania, 23 de octubre a las 3:00 pm. $5.00 por familia, solo efectivo, incluye la película, palomitas de maíz, bebida y dulces para todos. Los estudiantes deben estar acompañados por un adulto.',
        label: 'Español',
      },
    ],
    details: [
      {
        heading: 'Event details',
        items: [
          'Friday, October 23 at 3:00 PM',
          '$5.00 per family (cash only!)',
          'Includes the movie, popcorn, a drink, and candy for everyone',
          'Students must be accompanied by an adult',
        ],
      },
    ],
    pdf: '/assets/documents/family-movie-night-october-2026.pdf',
    pdfLabel: 'View the flyer (PDF, English and Spanish)',
  },
  {
    id: 'monster-mash-2026-10-30',
    title: 'Monster Mash Party and Costume Contest: October 30',
    date: '2026-10-15',
    summary:
      'Classes who earn a combined $1,000 ClassBank dollars win entry to our Monster Mash! Come in costume ready to do art, dance, snack, and take photos. ¡Ven disfrazado y listo para hacer arte, bailar, comer algo y sacarte fotos!',
    image: '/assets/images/flyers/monster-mash-october-2026.jpg',
    imageAlt:
      'Monster Mash flyer from ClassBank and Global Kids. Classes who earn a combined 1,000 ClassBank dollars earn entry. October 30. Kindergarten to 2nd grade 9:30 to 10:10 AM, grades 3 to 5 10:20 to 11:00 AM, grades 6 to 8 1:40 to 2:10 PM. Come in costume ready to do art, dance, snack, and take photos. Costume contest: 1st place 100 ClassBank dollars, 2nd place 50, 3rd place 25.',
    details: [
      {
        heading: 'Monster Mash schedule — Friday, October 30',
        items: [
          'Grades K–2: 9:30 – 10:10 AM',
          'Grades 3–5: 10:20 – 11:00 AM',
          'Grades 6–8: 1:40 – 2:10 PM',
        ],
      },
      {
        heading: 'Costume Contest (ClassBank prizes)',
        items: ['1st place — $100 ClassBank', '2nd place — $50 ClassBank', '3rd place — $25 ClassBank'],
      },
    ],
  },
  {
    id: 'spirit-week-2026-10-26',
    title: 'Spirit Week: October 26–30',
    date: '2026-10-08',
    summary:
      'Get ready, Lions! Spirit Week is almost here, and every day has a theme: Wacky Hair Day, Pajama Day, Wear Orange and Black, Silly Sock Day, and Costume Day on Friday. Look for the flyer below in English and Spanish.',
    image: '/assets/images/flyers/spirit-week-october-2026.jpg',
    imageAlt:
      'Spirit Week flyer, October 26 to 30. Monday 10/26: Wacky Hair Day. Tuesday 10/27: Pajama Day. Wednesday 10/28: Wear Orange and Black. Thursday 10/29: Silly Sock Day. Friday 10/30: Costume Day. Each day is also listed in Spanish.',
    details: [
      {
        heading: 'Spirit Week schedule',
        items: [
          'Monday, Oct 26 — Wacky Hair Day (¡Pelo alborotado!)',
          'Tuesday, Oct 27 — Pajama Day (¡Día de pijamas!)',
          'Wednesday, Oct 28 — Wear Orange and Black (¡Viste de naranja y negro!)',
          'Thursday, Oct 29 — Silly Sock Day (¡Día de los calcetines divertidos!)',
          'Friday, Oct 30 — Costume Day (¡Día de disfraces!)',
        ],
      },
    ],
  },
  {
    id: 'classbank-october-2026-10-08',
    title: 'ClassBank in October: How Students Earn',
    date: '2026-10-08',
    summary:
      'The ClassBank store is back for October! Students keep earning for coming to school, wearing their PS 96 uniform shirt, and following lunch rules or going to lunch club, and there are double-dollar days and a Costume Contest bonus this month.',
    image: '/assets/images/flyers/classbank-october-2026-student.jpg',
    imageAlt:
      'October ClassBank flyer, student version. Earn money by coming to school ($1 per day, $2 on 10/09, 10/13 and 10/19), wearing a PS 96 uniform shirt ($1 per day), following lunch rules in grades K to 2 or going to lunch club in grades 3 to 8, for a total of $3 per day. Special bonuses include immunization records, the BlueCard, an activated NYC Schools Account, and the 10/30 Costume Contest. Shop 10/05 to 10/14 and 10/19 to 10/28; purchases arrive 10/16 and 10/30.',
    details: [
      {
        heading: 'This month I earn money by',
        items: [
          'Coming to school — $1 per day (earn $2 on 10/09, 10/13 and 10/19)',
          'Wearing my PS 96 uniform shirt — $1 per day',
          'Kindergarten–2nd grade: following rules during lunch — $1 per day',
          'Grades 3–8: going to my lunch club — $1 per day',
          'Total: $3 per day',
        ],
      },
      {
        heading: 'Special bonuses',
        items: [
          'Immunization records — $10',
          'Turned in BlueCard to teacher — $10',
          'Activated NYC Schools Account (NYCSA) — $10',
          '10/30 Costume Contest — 1st place $100, 2nd place $50, 3rd place $25',
        ],
      },
      {
        heading: 'Important dates',
        items: [
          'Shop in the store Oct 5–14 and Oct 19–28',
          'Purchases are delivered Friday, Oct 16 and Friday, Oct 30',
          'Families can give up to $20 in bonuses by turning in the at-home bonus bank slips',
        ],
      },
    ],
  },
  {
    id: 'classbank-store-2026-09-23',
    title: 'Introducing ClassBank: Our New School Store',
    date: '2026-09-23',
    summary:
      'PS 96 Lions can now earn classroom dollars and spend them in our new school-wide ClassBank store — while learning real financial skills like saving, budgeting, and making smart choices.',
    image: '/assets/images/classbank/classbank-september-2026.jpg',
    imageAlt:
      'September ClassBank flyer (student version). Earn money by coming to school, wearing full uniform, and following lunch rules (K–2) or going to lunch club (grades 3–8), for $3 per day, plus bonuses. Shop Monday 9/28 through Thursday 10/1; purchases delivered Friday 10/2.',
    details: [
      {
        heading: 'This month I earn money by',
        items: [
          'Coming to school — $1 per day',
          'Wearing my full uniform — $1 per day',
          'Kindergarten–2nd grade: following rules during lunch — $1 per day',
          'Grades 3–8: going to my lunch club — $1 per day',
          'Total: $3 per day',
        ],
      },
      {
        heading: 'September bonuses ($1 each)',
        items: [
          'Terrific transitions, being positive, being a leader, being respectful, and trying hard',
          'Following the class contract, signed papers, helping my group, helping the whole class, and helping others',
        ],
      },
      {
        heading: 'Special bonuses',
        items: [
          'Parent/guardian attends Curriculum Night (Sept 30) — $10',
          'Turned in Blue Card to teacher — $10',
          'Activated NYC Schools Account (NYCSA) — $10',
          'Pre/post holiday attendance on Tuesday, Sept 22 — $2 (double dollar day)',
        ],
      },
      {
        heading: 'Important dates',
        items: [
          'Store is open Monday, Sept 28 – Thursday, Oct 1',
          'First purchases are delivered Friday, Oct 2',
          'Families can give up to $5 in bonuses by turning in the at-home bonus slips',
        ],
      },
    ],
    pdf: '/assets/documents/classbank-september-2026.pdf',
  },
  {
    id: 'first-day-of-school-2026-09-10',
    title: 'Welcome Back, Lions! First Day of School 2026',
    date: '2026-09-10',
    summary:
      'Big smiles, new backpacks, and plenty of first-day excitement! Thank you to all of our families and staff for a wonderful start to the 2026–2027 school year.',
    photos: [
      { src: '/assets/images/gallery/first-day-2026-sisters.jpg', alt: 'Two smiling young girls with backpacks, dressed in matching striped tops and floral skirts, stand outside the PS 96 entrance on the first day of school' },
      { src: '/assets/images/gallery/first-day-2026-kindergarten.jpg', alt: 'A kindergarten teacher holding a red folder stands hand in hand with a young student in a paper hat and school uniform beside a Class K-11 sign on the school fence' },
      { src: '/assets/images/gallery/first-day-2026-family.jpg', alt: 'A teacher holding a class sign poses on the sidewalk with a smiling student and her grandmother on the first day of school' },
      { src: '/assets/images/gallery/first-day-2026-teachers.jpg', alt: 'Two smiling PS 96 teachers stand arm in arm on the sidewalk in front of a yellow school bus on the first day of school' },
    ],
    photoLink: '/picture-gallery',
  },
  {
    id: 'celebrity-substitute-2025-10-08',
    title: 'Celebrity Substitute',
    date: '2025-10-08',
    summary:
      'A special guest stepped in as a celebrity substitute at PS 96. Watch the full reveal on our YouTube channel.',
    youtubeId: 'SXngA8APZzc',
    link: 'https://youtu.be/SXngA8APZzc?si=Yz8jgpPdQQbc85sa',
  },
];

export default announcements;
